var mktRegionMapping = {
    CN: "china",
    HK: "china",
    MO: "china",
    TW: "china",
    US: "americas",
    CA: "americas",
    CO: "latam",
    VE: "latam",
    AR: "latam",
    MX: "latam",
    BR: "latam",
    CL: "latam",
    CR: "latam",
    SV: "latam",
    GT: "latam",
    HN: "latam",
    AT: "europe",
    BE: "europe",
    CH: "europe",
    DE: "europe",
    ES: "europe",
    FR: "europe",
    GB: "europe",
    IT: "europe",
    LU: "europe",
    NL: "europe",
    PT: "europe",
    CZ: "europe",
    HU: "europe",
    PL: "europe",
    RO: "europe",
    RU: "europe",
    SK: "europe",
    TR: "europe",
    UA: "europe",
    DK: "europe",
    FI: "europe",
    IE: "europe",
    IS: "europe",
    NO: "europe",
    SE: "europe",
    ZA: "europe",
    IL: "europe",
    BN: "south-east-asia",
    ID: "south-east-asia",
    MY: "south-east-asia",
    PH: "south-east-asia",
    SG: "south-east-asia",
    TH: "south-east-asia",
    VN: "south-east-asia",
    AU: "south-pacific",
    NZ: "south-pacific",
    PF: "south-pacific",
    FJ: "south-pacific",
    NC: "south-pacific",
    JP: "nasia",
    KR: "nasia"
};

export default mktRegionMapping;


//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/regionMapping.js
// module id = 28
// module chunks = 0